module.exports = __webpack_public_path__ + "static/img/技术参数BG.1159467.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/技术参数BG.png
// module id = 7BQr
// module chunks = 0